import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/access';
import { EnterprisesPage } from '@/features/enterprise/list-page';

export const Route = createFileRoute('/_authenticated/operations/enterprises/')(
  {
    beforeLoad: ({ context, location }) =>
      requirePermission(context.queryClient, location.href, 'enterprises:read'),
    component: EnterprisesPage,
  },
);
